import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"
import axios from "./api/http"
import api from "./api/api"
import ElementUI from "element-ui"
import "./assets/css/element-variables.scss"
import "./assets/css/globle.scss"

Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.$api = api
Vue.prototype.$bizSys = "1" // 系统编码 (1总后台；2门店)

Vue.use(ElementUI)

Vue.component("back", () => import("./components/back.vue"))

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount("#app")
